import { useState } from "react";
import { cn } from "utils/cn";

interface SubheaderBackButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
};

const SubheaderBackButton = ({ label, onClick, className }: SubheaderBackButtonProps) => {
  const [hover, setHover] = useState(false);
  return (
    <button
      className={cn("flex text-primary-teal items-center", className)}
      onClick={() => onClick()}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <i className={`${hover ? "fa-solid" : "fa-regular"} fa-circle-left mr-1`} />
      <p className="font-normal hover:font-semibold">{label}</p>
    </button>
  );
};

export default SubheaderBackButton;